import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import PaginationOptions from '../models/PaginationOptions';
import * as Global from '../global';
import FilterOptions from '../models/FilterOptions';
@Injectable({
  providedIn: 'root',
})
export class ExpenseService {
  Global = Global;
  expenses: any[] = [];
  paginationValue: PaginationOptions = Global.resetPaginationOptions();
  filterValue: FilterOptions = Global.resetTableFilterOptions();
  scrollPosition = 0;
  selectedId = null;
  constructor(private httpService: HttpService) { }
  deleteExpense(expenseId: string) {
    // Find the index of the expense to delete
    const expenseIndex = this.expenses.findIndex(
      (expense) => expense.id === expenseId
    );

    // If the expense is found, remove it from the array
    if (expenseIndex !== -1) {
      this.expenses.splice(expenseIndex, 1);
    } else {
      console.error(`Expense with id ${expenseId} not found.`);
    }
  }
  updateExpense(expenseId: string) {
    // Find the index of the expense to update
    const expenseIndex = this.expenses.findIndex(
      (expense) => expense.id === expenseId
    );

    // If the expense is found, update it
    if (expenseIndex !== -1) {
      let params = new URLSearchParams();
      params.set('MasterExpenseId', String(expenseId));
      this.fetchExpenses({ params }).subscribe({
        next: (res: any) => {
          const data = res?.data[0] ?? null;
          if (data) {
            // Update the trip with the fetched data
            this.expenses[expenseIndex] = {
              ...this.expenses[expenseIndex],
              ...data,
            };
          } else {
            console.error('No data found for the expense.');
          }
        },
        error: (err: any) => {
          console.error('Error fetching expense data:', err);
        },
        complete: () => { },
      });
    } else {
      console.error(`Expense with id ${expenseId} not found.`);
    }
  }
  setExpenses(
    expenses: any[],
    paginationValue: PaginationOptions,
    filterValue: FilterOptions
  ) {
    this.expenses = expenses;
    this.paginationValue = paginationValue;
    this.filterValue = filterValue;
  }
  getExpenses() {
    return {
      expenses: this.expenses,
      paginationValue: this.paginationValue,
      filterValue: this.filterValue,
    };
  }
  setScrollPosition(scrollPosition: number) {
    this.scrollPosition = scrollPosition;
  }
  getScrollPostion() {
    return this.scrollPosition;
  }
  setSelectedId(id: any) {
    this.selectedId = id;
  }
  getSelectedId() {
    return this.selectedId;
  }
  clearData() {
    this.expenses = [];
    this.selectedId = null;
    this.scrollPosition = 0;
    this.paginationValue = Global.resetPaginationOptions();
    this.filterValue = Global.resetTableFilterOptions();
  }

  
  addExpenseWithDetails(payload: any, addItem: any) {
    if (addItem) {
      return this.httpService.post(
        // 'api/Expense/AddExpenseWithDetails',
        'api/Expense/AddExpenseWithDetailsV26',
        payload
      );
    } else {
      return this.httpService.post(
        // 'api/Expense/UpdateExpenseWithDetails',
        'api/Expense/UpdateExpenseWithDetailsV26',
        payload
      );
    }
  }
  addLocalConveyanceExpense(payload: any, update: any) {
    if (update) {
      return this.httpService.put(
        'api/Expense/UpdateLocalConveyanceExpense',
        payload
      );
    } else {
      return this.httpService.post(
        'api/Expense/AddLocalConveyanceExpense',
        payload
      );
    }
  }
  updateLocalConveyanceExpense(payload: any) {
    return this.httpService.put(
      'api/Expense/UpdateLocalConveyanceExpense',
      payload
    );
  }
  UpdateAllExpenseStatus(payload: any) {
    return this.httpService.put('api/Expense/AllUpdateExpenseStatus', payload);
  }
  updateMasterExpenseStatus(payload: any) {
    return this.httpService.put(
      'api/Expense/UpdateMasterExpenseStatus/' + payload?.id,
      payload
    );
  }
  getExpensesLocalConveyance(payload: any) {
    return this.httpService.getList(
      'api/Expense/GetExpensesLocalConveyance',
      payload
    );
  }
  deleteLocalConveyanceExpense(id: string) {
    return this.httpService.delete(
      'api/Expense/DeleteLocalConveyanceExpense/' + id
    );
  }
  deleteLocalConveyanceExpenseDocument(id: string) {
    return this.httpService.delete(
      'api/Expense/DeleteLocalConveyanceExpenseDocument/' + id
    );
  }

  addCarBikeLogBookExpense(payload: any, update: any) {
    if (update) {
      return this.httpService.put(
        'api/Expense/UpdateCarBikeLogBookExpense',
        payload
      );
    } else {
      return this.httpService.post(
        'api/Expense/AddCarBikeLogBookExpense',
        payload
      );
    }
  }
  getCarBikeLogBookExpense(payload: any) {
    return this.httpService.getList(
      'api/Expense/GetCarBikeLogBookExpense',
      payload
    );
  }
  updateCarBikeLogBookExpense(payload: any) {
    return this.httpService.put(
      'api/Expense/UpdateCarBikeLogBookExpense',
      payload
    );
  }
  deleteCarBikeLogBookExpense(id: string) {
    return this.httpService.delete(
      'api/Expense/DeleteCarBikeLogBookExpense/' + id
    );
  }
  deleteCarBikeLogBookExpenseDocument(id: string) {
    return this.httpService.delete(
      'api/Expense/DeleteCarBikeLogBookExpenseDocument/' + id
    );
  }
  deleteExpenseByDate(payload: any) {
    return this.httpService.delete('api/Expense/DeleteExpenseByDate', payload);
  }
  addExpenseDetails(payload: any) {
    return this.httpService.post('api/Expense/AddExpenseDetails', payload);
  }
  updateExpenseDetails(payload: any) {
    return this.httpService.put('api/Expense/UpdateExpenseDetails', payload);
  }
  AllAccountUpdateExpenseAndMasterExpense(payload: any) {
    return this.httpService.put(
      'api/Expense/AllAccountUpdateExpenseAndMasterExpense',
      payload
    );
  }
  UpdateAllExpenseAndMasterExpenseApprovalLevel(payload: any) {
    return this.httpService.put(
      'api/Expense/UpdateAllExpenseAndMasterExpenseApprovalLevel',
      payload
    );
  }
  updateExpenseAccountTeam(payload: any) {
    return this.httpService.put(
      'api/Expense/ChangeExpenseAccountTeam',
      payload
    );
  }
  fetchMasterExpenses(payload: any) {
    return this.httpService.getList(
      'api/Expense/GetMasterExpensesList',
      payload
    );
  }
  fetchExpenses(payload: any) {
    return this.httpService.getList(
      'api/Expense/GetAllExpensesDetailsList',
      payload
    );
  }
  fetchTaxCodes(payload: any) {
    return this.httpService.getList('api/TaxCodes', payload);
  }
  getCostCenterBranches(payload: any) {
    return this.httpService.getList('api/GetCostCenterBranches', payload);
  }
  GetBusinessAreas(payload: any) {
    return this.httpService.getList('api/GetBusinessAreas', payload);
  }
  SendToSAP(payload: any) {
    return this.httpService.post('api/Expense/SendToSAP', payload);
  }
  AllUpdateExpenseStatusForDirector(payload: any) {
    return this.httpService.put(
      'api/Expense/AllUpdateExpenseStatusForDirector',
      payload
    );
  }
  getSapParkingRecords(payload: any) {
    return this.httpService.get(
      'api/Expense/GetSapParkingRecords/' + payload?.id
    );
  }
  getAllLocalConveyCarBikeExpensesListReport(id: string, payload: any = {}) {
    return this.httpService.getList(
      'api/Expense/GetAllLocalConveyCarBikeExpensesListReport/' + id, payload
    );
  }
  UpdateExpenseCityType(payload: any) {
    return this.httpService.put(
      'api/Expense/UpdateExpenseCityType',
      payload
    );
  }  
  ReversedDocumentToSAP(payload: any) {
    return this.httpService.post(
      'api/Expense/ReversedDocumentToSAP',
      payload
    );
  }
    fetchExpensesGroupWise(payload: any) {
    return this.httpService.getList(
      'api/Expense/GetAllExpensesDetailsListGroupWiseV26',
      payload
    );
  }
  getExpenseDetailsReport(payload: any) {
    return this.httpService.post(
      'api/Report/GetExpenseDetailsReport',
      payload
    );
  }
  deleteExpenseDocument(id: string) {
    return this.httpService.delete('api/Expense/DeleteExpenseDocument/' + id);
  }
  addExpenseDocument(payload: any) {
    return this.httpService.post('api/Expense/AddExpenseDocument', payload);
  }
  deleteTravelDocument(id: string) {
    return this.httpService.delete('api/Expense/DeleteTravelDocument/' + id);
  }
  getExpensesDetailsReportDateWise(id: string, payload: any = {}) {
    return this.httpService.getList(
      'api/Expense/GetExpensesDetailsReportDateWise/' + id, payload
    );
  }
  deleteExpenseMaster(id: string) {
    return this.httpService.delete('api/Expense/DeleteMasterExpense/' + id);
  }
  deleteExpenseById(id: string) {
    return this.httpService.delete('api/Expense/' + id);
  }
  UpdateMasterExpenseCompany(payload: any) {
    return this.httpService.put(
      'api/Expense/UpdateMasterExpenseCompany/',
      payload
    );
  }
  updateExpenseStatus(payload: any) {
    return this.httpService.put(
      'api/Expense/UpdateExpenseStatus/' + payload?.id,
      payload
    );
  }
  submitTravelDocument(payload: any, addItem: boolean) {
    if (addItem) {
      return this.httpService.post('api/Expense/AddTravelDocument', payload);
    } else {
      return this.httpService.post('api/Expense/UpdateTravelDocument', payload);
    }
  }
  fetchExpenseTrackings(payload: any) {
    return this.httpService.getList('api/Expense/GetExpenseTrackings', payload);
  }
  addtExpenseRemarks(payload: any) {
    return this.httpService.post('api/Expense/AddExpenseTracking', payload);
  }
  getTravelDocument(payload: any) {
    return this.httpService.getList(
      `api/Expense/GetTravelDocument/${payload?.userid}`,
      payload
    );
  }
  downloadExpenseReceipt(id: string) {
    return this.httpService.downloadFile(`api/Expense/${id}/download`);
  }
  downloadTravelDeskExpenseReceipt(id: string) {
    return this.httpService.downloadFile(
      `api/Expense/${id}/downloadTravelDeskFile`
    );
  }
  downloadTravelDocument(id: string) {
    return this.httpService.downloadFile(
      `api/Expense/${id}/downloadTravelDocument`
    );
  }
  updateExpenseAndMasterExpense(payload: any) {
    return this.httpService.put(
      'api/Expense/UpdateExpenseAndMasterExpense',
      payload
    );
  }
  updateExpenseBill(payload: any) {
    return this.httpService.put(`api/Expense/${payload?.id}`, payload);
  }
  downloadAllExpenseAttachment(id: string) {
    return this.httpService.get('api/Expense/DownloadAllExpenseZipFile/' + id);
  }
  getExistingExpenseByTrip(id: string) {
    return this.httpService.get(`api/Expense/GetExistingExpenseByTrip/${id}`);
  }
}
